import { executeOnce, getNonEmptyArrayLastElement } from '../../../utils'

import type { CybusDetailedService } from '../../../domain'

import { FileExtensionType } from '../..'
import { Usecase } from '..'

export class DownloadServiceUsecase extends Usecase {
    private readonly getExtension = executeOnce(() =>
        getNonEmptyArrayLastElement(this.configurationService.getSupportedFileExtensions(FileExtensionType.SERVICE_COMMISSIONING))
    )

    async invoke ({ id, updatedAt }: CybusDetailedService): Promise<void> {
        const fileContent = await this.connectwareServicesService.fetchCommissioningFile(id)

        const fileName = `${id}.${this.getExtension()}`
        const type = this.configurationService.getServiceCommissioningFileDownloadMimeType()
        const lastModified = updatedAt ? updatedAt.getTime() : undefined

        this.fileService.download(new File([fileContent], fileName, { type, lastModified }))
    }
}
